module.exports = __webpack_public_path__ + "img/suhaimi.b46fa8a1.png";